import React from "react";
import { useSearchParams } from "react-router-dom";
import Integration from "@/model/interface/Integration";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import SalesforceSettings from "./SalesforceSettings";
import SalesforceFieldMapping from "./SalesforceFieldMapping";
import SalesforceUserMapping from "./SalesforceUserMapping";
import SalesforceImport from "./SalesforceImport";
import IntegrationSyncLog from "../IntegrationSyncLog";
import IntegrationPushQueue from "../IntegrationPushQueue";

const TABS = ["settings", "field-mapping", "user-mapping", "import", "push-queue", "sync-log"] as const;
type Tab = (typeof TABS)[number];

interface Props {
  integration: Integration;
}

export default function SalesforceDetail({ integration }: Props) {
  const [searchParams, setSearchParams] = useSearchParams();
  const tabParam = searchParams.get("tab");
  const activeTab: Tab = TABS.includes(tabParam as Tab) ? (tabParam as Tab) : "settings";

  const setTab = (tab: string) => {
    setSearchParams({ tab }, { replace: true });
  };

  return (
    <Tabs value={activeTab} onValueChange={setTab}>
      <TabsList>
        <TabsTrigger value="settings">Settings</TabsTrigger>
        <TabsTrigger value="field-mapping">Field Mapping</TabsTrigger>
        <TabsTrigger value="user-mapping">User Mapping</TabsTrigger>
        <TabsTrigger value="import">Import</TabsTrigger>
        <TabsTrigger value="push-queue">Push Queue</TabsTrigger>
        <TabsTrigger value="sync-log">Sync Log</TabsTrigger>
      </TabsList>

      <TabsContent value="settings" className="mt-6">
        <SalesforceSettings integration={integration} />
      </TabsContent>

      <TabsContent value="field-mapping" className="mt-6">
        <SalesforceFieldMapping integration={integration} />
      </TabsContent>

      <TabsContent value="user-mapping" className="mt-6">
        <SalesforceUserMapping integration={integration} />
      </TabsContent>

      <TabsContent value="import" className="mt-6">
        <SalesforceImport />
      </TabsContent>

      <TabsContent value="push-queue" className="mt-6">
        <IntegrationPushQueue service={integration.service} />
      </TabsContent>

      <TabsContent value="sync-log" className="mt-6">
        <IntegrationSyncLog integrationId={integration.id} />
      </TabsContent>
    </Tabs>
  );
}
